"use client";

import { PublicOnlyGate } from "@/components/public-only-gate";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <PublicOnlyGate>
      <div className="min-h-screen">{children}</div>
    </PublicOnlyGate>
  );
}
